
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const signUp = async (
  email: string, 
  password: string, 
  metadata?: { first_name?: string; last_name?: string }
): Promise<void> => {
  try {
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: metadata,
      },
    });

    if (error) throw error;
    toast.success('Signup successful! Please check your email for verification.');
  } catch (error: any) {
    toast.error(error.message || 'Failed to sign up');
    throw error;
  }
};

export const signIn = async (
  email: string, 
  password: string
): Promise<void> => {
  try {
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) throw error;
    toast.success('Successfully signed in');
    // Navigation is now handled by the auth state change listener
  } catch (error: any) {
    toast.error(error.message || 'Failed to sign in');
    throw error;
  }
};

export const signInWithMicrosoft = async (): Promise<void> => {
  try {
    console.log('Initiating Microsoft sign in...');
    
    // Get absolute URL for redirect - use the current full URL origin, not localhost
    const currentUrl = window.location.origin;
    const redirectUrl = `${currentUrl}/auth`; 
    console.log('Redirect URL set to:', redirectUrl);
    
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'azure',
      options: {
        redirectTo: redirectUrl,
        scopes: 'email profile openid User.Read Team.ReadBasic.All Group.Read.All',
        queryParams: {
          prompt: 'consent' // Force consent screen to show all permissions
        }
      }
    });
    
    if (error) {
      console.error('Microsoft OAuth error:', error);
      toast.error(error.message || 'Failed to sign in with Microsoft');
      throw error;
    }
    
    console.log('Microsoft auth initiated, redirecting to:', data?.url);
  } catch (error: any) {
    console.error('Microsoft sign in error details:', error);
    toast.error(error.message || 'Failed to sign in with Microsoft');
    throw error;
  }
};

export const signOut = async (): Promise<void> => {
  try {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
  } catch (error: any) {
    toast.error(error.message || 'Failed to sign out');
    throw error;
  }
};

export const resetPassword = async (email: string): Promise<void> => {
  try {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    if (error) throw error;
    toast.success('Password reset email sent. Please check your inbox.');
  } catch (error: any) {
    toast.error(error.message || 'Failed to send reset email');
    throw error;
  }
};
